"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Variant = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _VariantLink = require("./VariantLink");
require("./Variant.scss");
const Variant = _ref => {
  let {
    className,
    onProductClick,
    variant
  } = _ref;
  const {
    sku,
    url,
    thumbnail,
    label
  } = variant;
  const rootClassName = (0, _classnames.default)('cds-ProductBox-Variant', {
    'cds-ProductBox-Variant--Title': !thumbnail
  }, className);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: rootClassName
  }, /*#__PURE__*/_react.default.createElement(_VariantLink.VariantLink, {
    sku: sku,
    url: url,
    onProductClick: onProductClick,
    thumbnail: thumbnail,
    label: label
  }));
};
exports.Variant = Variant;
//# sourceMappingURL=Variant.js.map